define('taoQtiItem/qtiCreator/widgets/choices/states/Answer',[
    'taoQtiItem/qtiCreator/widgets/states/factory',
    'taoQtiItem/qtiCreator/widgets/states/Answer'
], function(stateFactory, Answer){

    var ChoiceStateAnswer = stateFactory.create(Answer, function(){
        
    }, function(){
        
    });
        
    return ChoiceStateAnswer;
});
